module.exports = __webpack_public_path__ + "static/media/識別圖片播放背景音.df187ac5.png";